<template>
  <div class="box">
    <div class="field is-grouped is-grouped-right">
      <div class="control">
        <button class="button is-link" @click="submitData()">Update Role</button>
      </div>
    </div>
    <table class="table is-fullwidth">
      <tr>
        <th>Name</th>
        <th>Previous Ministry</th>
        <th>Role</th>
        <th>Action</th>
      </tr>
      <tr v-for="(member_row, index) in member_list" :key="index">
        <td v-text="member_row.name"></td>
        <td v-text="member_row.previous_ministry"></td>
        <td>
          <div class="select">
            <select v-model="member_list[index].role_id">
              <option value="">Select Role</option>
              <option v-for="(role_row, index_role) in role_list" :key="index_role" :value="role_row.id" v-text="role_row.title"></option>
            </select>
          </div>
        </td>
        <td></td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      member_list: [],
      role_list: []
    }
  },
  created () {
    if (this.getSessionItem('id_token') === null || this.getSessionItem('access_token') === null) {
      this.$router.push('/panel/logout')
    }
    this.getMember()
    this.getRole()
  },
  methods: {
    getMember () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyGetSession('head/member/get_member')
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.member_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    getRole () {
      var self = this
      self.flyGetSession('head/role/get_role')
      .then(function (response) {
        if (response.data.response_code === 1) {
          self.role_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    submitData () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPostSession('head/member/set_member_role', {
        member: this.member_list
      })
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          alert('Update Member Role Success')
          self.$router.push('/panel/member')
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/member/Role.vue